import { locales, type Locale } from '@/i18n/locales'
import type { TransMode } from '@/services/wapi/types/c2c'

/**
 * The modes a city guide exists in, in the order a city with no page in the requested
 * mode is redirected through. The route admits only these, the page type names only
 * these in its other-mode links, the content gate checks each one's copy tier, and the
 * request boundary hands a guide in any other route mode to the legacy origin.
 */
export const GUIDE_MODES = ['bus', 'train', 'ferry'] as const satisfies readonly TransMode[]

export type GuideMode = (typeof GUIDE_MODES)[number]

/**
 * The locales and modes whose city-guide copy the content gate checks: every routing
 * locale, in every guide mode. An environment's served locales and modes must stay within
 * these, so a guide it serves never renders from copy the gate has not checked.
 */
export const CITY_GUIDE_SERVING = {
    locales,
    modes: GUIDE_MODES,
} as const satisfies { locales: readonly Locale[]; modes: readonly TransMode[] }
